import { quotesIcon } from '@/assets/icons'
import Image from 'next/image'
import { StaticImageData } from 'next/image'

type Props = {
  feedback: string
  name: string
  img: string | StaticImageData
}

const TestimonialCard = ({ feedback, name, img }: Props) => {
  return (
    <div className='relative  mx-3 flex cursor-grab items-center justify-center rounded-lg bg-linear-to-br from-primary from-10% to-secondary px-5 pt-8 shadow-lg sm:pb-10 md:py-14 lg:py-20 xl:px-20 xl:py-20'>
      <Image alt='Testimonial icon' src={quotesIcon} className='absolute  -top-4 w-12' />
      <p className='line-clamp-6 flex h-80 items-center justify-center overflow-hidden text-ellipsis pb-8 text-center sm:h-48 sm:pb-0 md:h-80 lg:pb-5 lg:text-xl'>
        {feedback}
      </p>
      <div className='absolute -bottom-24 flex flex-col items-center lg:-bottom-16'>
        <Image alt='Testimonial card' src={img} className='w-24 rounded-full' />
        <p className='text-xl font-semibold text-orange'>{name}</p>
      </div>
    </div>
  )
}

export default TestimonialCard
